/* @flow */

export default class RegisterLeadResponse {
  leadId: number;
  leadAlreadyExist: boolean;
}
